<template>
  <a-dialog ref="dialog" name="change_plan_cancel" :loading="loading" @open="opened" @close="$reset">
    <span slot="title">
      {{ $t('title') }}
    </span>
    <div slot="content" v-if="estimate">
      <div>
        {{ $t('offer', {date: $helpers.present.date(subscription.period.end)}) }}
      </div>
      <subscription-estimate
          class="mt-4"
          :subscription="subscription"
          :estimate="estimate">
      </subscription-estimate>
    </div>
    <span slot="actions">
      <v-btn color="warning" text @click="cancel()">
        {{ $t('actions.remove') }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
import SubscriptionEstimate from '../../Subscription/Common/SubscriptionEstimate'

export default {
  name: 'ChangePlanCancelDialog',
  components: { SubscriptionEstimate },
  data() {
    return {
      loading: '',
      subscription: null,
      estimate: null
    }
  },
  methods: {
    async opened(subscription) {
      this.subscription = subscription
      this.loading = this.$t('estimations')

      try {
        this.estimate = (await this.$api.post('account/customer/subscription/estimate', {
          existing: true,
          module: this.subscription.module
        })).data
      } finally {
        this.loading = ''
      }
    },
    async cancel() {
      try {
        this.loading = this.$t('removal')
        await this.$api.delete('account/customer/subscription/update_at_end', {
          module: this.subscription.module
        })

        this.loading = this.$t('update')
        await this.$account.fetch()

        this.$ui.success(this.$t('edit-sucess'))
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"edit-sucess": "The change was deleted successfully!",
		"error": "An error occurred while canceling the termination:",
		"estimations": "Estimation of modifications ...",
		"offer": "Your offer will be reduced upon renewal on {date}. Below are the changes that will be applied. You can remove these changes by clicking \"remove\".",
		"removal": "Deletion of your order ...",
		"title": "Modification of the offer",
		"update": "Updating your subscription ..."
	},
	"es": {
		"edit-sucess": "¡El cambio se eliminó con éxito!",
		"error": "Ocurrió un error al cancelar la rescisión:",
		"estimations": "Estimación de modificaciones ...",
		"offer": "Su oferta se reducirá tras la renovación el {date}. A continuación se muestran los cambios que se aplicarán. Puede eliminar estos cambios haciendo clic en \"eliminar\".",
		"removal": "Eliminación de su pedido ...",
		"title": "Modificación de la oferta",
		"update": "Actualizando su suscripción ..."
	},
	"fr": {
		"edit-sucess": "La modification a été supprimée avec succès !",
		"error": "Une erreur est survenue lors de l'annulation de la résiliation : ",
		"estimations": "Estimation des modifications ...",
		"offer": "Votre offre sera diminuée au renouvellement, le {date}. Ci-dessous les modifications qui seront appliquées. Vous pouvez supprimer ces modifications en cliquant sur \"supprimer\".",
		"removal": "Suppression de votre commande ...",
		"title": "Modification de l'offre",
		"update": "Mise à jour de votre souscription ..."
	},
	"it": {
		"edit-sucess": "La modifica è stata eliminata con successo!",
		"error": "Si è verificato un errore durante l'annullamento della disdetta:",
		"estimations": "Stima delle modifiche ...",
		"offer": "La tua offerta sarà ridotta al rinnovo il {date}. Di seguito le modifiche che verranno applicate. Puoi rimuovere queste modifiche cliccando su \"elimina\".",
		"removal": "Eliminazione del tuo ordine ...",
		"title": "Modifica dell'offerta",
		"update": "Aggiornamento del tuo abbonamento ..."
	},
	"pt": {
		"edit-sucess": "A alteração foi eliminada com sucesso!",
		"error": "Ocorreu um erro ao cancelar o cancelamento:",
		"estimations": "Estimativa das alterações ...",
		"offer": "A sua oferta será reduzida na renovação em {date}. Abaixo encontram-se as alterações que serão aplicadas. Pode remover estas alterações clicando em \"eliminar\".",
		"removal": "A eliminar o seu pedido ...",
		"title": "Modificação da oferta",
		"update": "A atualizar a sua subscrição ..."
	},
	"pl": {
		"edit-sucess": "Zmiana została pomyślnie usunięta!",
		"error": "Wystąpił błąd podczas anulowania rozwiązania:",
		"estimations": "Szacowanie modyfikacji ...",
		"offer": "Twoja oferta zostanie obniżona przy odnowieniu dnia {date}. Poniżej znajdują się zmiany, które zostaną zastosowane. Możesz usunąć te zmiany klikając \"usuń\".",
		"removal": "Usuwanie Twojego zamówienia ...",
		"title": "Modyfikacja oferty",
		"update": "Aktualizacja Twojej subskrypcji ..."
	}
}
</i18n>
